import React from 'react'

const LoginFillIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6 1.5H10.65C8.25 1.5 6.75 3 6.75 5.4V8.4375H10.08L8.5275 6.885C8.415 6.7725 8.3625 6.63 8.3625 6.4875C8.3625 6.345 8.415 6.2025 8.5275 6.09C8.745 5.8725 9.105 5.8725 9.3225 6.09L11.835 8.6025C12.0525 8.82 12.0525 9.18 11.835 9.3975L9.3225 11.91C9.105 12.1275 8.745 12.1275 8.5275 11.91C8.31 11.6925 8.31 11.3325 8.5275 11.115L10.08 9.5625H6.75V12.6C6.75 15 8.25 16.5 10.65 16.5H12.5925C14.9925 16.5 16.4925 15 16.4925 12.6V5.4C16.5 3 15 1.5 12.6 1.5Z"
        fill="currentColor"
      />
      <path
        d="M2.0625 8.4375C1.755 8.4375 1.5 8.6925 1.5 9C1.5 9.3075 1.755 9.5625 2.0625 9.5625H6.75V8.4375H2.0625Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default LoginFillIcon
